import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import Alert from "react-bootstrap/Alert";
import Modal from "react-modal";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import WelcomeUser from "../Open-pages/user/WelcomeUser";
import Notifications from "../push-notifications/Notifications";
import CommonStructured from "../common-components/CommonStructured";
import TSForm from "./TSForm";
import "../../styles/time-sheet/time-sheet.css";
import {
  fetchSheetContentData,
  fetchTimeSheetData,
} from "../../redux/reducers/apiSlice";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { EditIcon } from "../../images/icons/website-icons";
import TimeSheetFilter from "./time-sheet-filter";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import { convertStraight } from "../common-data/Converts";
import TSView from "./TSView";
import { CrossIcon, ExpandIcon, RightIcon } from "../../images/icons/icons";
import { fetchReceptionistBySlotData } from "../../redux/reducers/dropdownApiSlice";

const TSLanding = ({
  userInfoData,
  isCustom,
  isIOS,
  // isNotificationDenied
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const modalRef = useRef(null);

  const isAdmin = userInfoData?.account_type === "admin";
  const isReceptionist = userInfoData?.account_type === "receptionist";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const { timeSheetData, sheetContentData, loading } = useSelector(
    (state) => state.api
  );

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const [expanded, setExpanded] = React.useState(false);

  const initialFilters = {
    page: isPage + 1,
    limit: pageLimit,
    gym_id: !isAdmin
      ? userInfoData?.gym_id || userInfoData?.user_id || userInfoData?.uid || ""
      : "",
    user_id: "",
    approval_status: "",
    sheet_date: "",
    status: !isReceptionist ? "active" : "",
  };
  const [filters, setFilters] = useState(initialFilters);

  function getFDShift(filter) {
    dispatch(
      fetchReceptionistBySlotData({
        filters: filter,
        token: userInfoData?.token,
      })
    );
  }

  // console.log("sheetContentData===>", sheetContentData);

  // const approvedCount =
  //   sheetContentData &&
  //   sheetContentData?.data?.filter((item) => item.is_approved === 1).length;
  // const totalCount = sheetContentData?.data?.length;
  // const rejectedCount = totalCount - approvedCount;

  useEffect(() => {
    if (userInfoData?.uid || userInfoData?.user_id) {
      const filters = {
        user_id: userInfoData?.uid || userInfoData?.user_id || "",
      };

      getFDShift(filters);
    }
  }, []);

  // Update filters when userInfoData changes
  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      page: isPage + 1,
      limit: pageLimit,
      gym_id: !isAdmin
        ? userInfoData?.gym_id ||
          userInfoData?.user_id ||
          userInfoData?.uid ||
          ""
        : "",
    }));
  }, [isPage, pageLimit, userInfoData?.gym_id]);

  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
    image: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD format

  let todaySheet = null;
  if (timeSheetData?.data[0]?.sheet_date === today) {
    todaySheet = timeSheetData?.data[0];
  }

  function handleModalClose() {
    setModValues(iniModvalues);
  }

  const handleBack = (e) => {
    e.preventDefault();

    navigate("/open-access/all-pages", {
      state: { userInfo: userInfoData, decryptedText: userInfoData },
    });
  };

  function getTimeSheetDetails(filters) {
    const apiFilters = {
      ...filters,
      sheet_date: filters.sheet_date || "",
      approval_status: filters.approval_status?.value || "",
      user_id: filters.user_id?.value || "",
      gym_id: filters.gym_id?.value || filters.gym_id || "",
    };

    dispatch(
      fetchTimeSheetData({
        filters: apiFilters,
        token: userInfoData?.token,
      })
    );
  }

  // console.log("filters", filters);

  useEffect(() => {
    getTimeSheetDetails(filters);
  }, [filters, userInfoData?.gym_id]);

  const handleEdit = (row) => {
    dispatch(
      fetchSheetContentData({ uid: row?.uid, token: userInfoData?.token })
    );

    setModValues({
      isModOpen: true,
      cardName: "edit",
      rowData: row,
    });
  };

  const handleView = (row) => {
    dispatch(
      fetchSheetContentData({ uid: row?.uid, token: userInfoData?.token })
    );

    setModValues({
      isModOpen: true,
      cardName: "view",
      rowData: row,
    });
  };

  const handleReset = () => {
    setFilters(initialFilters);
  };

  const timeSheetColumns = [
    {
      dataField: "sheet_date",
      text: "Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.sheet_date ? convertStraight(row.sheet_date) : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "user_details",
      text: "User Details",
      formatter: (name, row) => {
        return (
          <span className="tb-data">
            {row?.user_name || "NA"}
            <br />
            <small className="lowercase underline gray">
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "status",
      text: "Sheet Status",
      formatter: (cell, row) => {
        return (
          <span className="tb-data status-dot">
            <span
              className="d-inline-block rounded-circle"
              style={{
                width: "8px",
                height: "8px",
                backgroundColor:
                  row?.status?.toLowerCase() === "draft"
                    ? "#A0A0A0"
                    : "#28a745",
              }}
            />
            <span
              style={{
                color:
                  row?.status?.toLowerCase() === "draft"
                    ? "#A0A0A0"
                    : "#28a745",
              }}
            >
              {row?.status?.toLowerCase() === "draft" ? "Draft" : "Submitted"}
            </span>
          </span>
        );
      },
    },
    {
      dataField: "approval_status",
      text: "Approval Action ",
      formatter: (cell, row) => {
        return (
          <span className="tb-data ">
            {/* <span
              className="d-inline-block rounded-circle"
              style={{
                width: "8px",
                height: "8px",
                backgroundColor:
                  row?.approval_status === 0
                    ? "#ffc107"
                    : row?.approval_status === 1
                    ? "#28a745"
                    : "#dc3545",
              }}
            /> */}
            <span>
              {row?.approval_status === 0 ? <CrossIcon /> : <RightIcon />}
            </span>
          </span>
        );
      },
    },
    {
      dataField: "approval_status",
      text: "Approval Status",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.total_approved}/{row?.total_timesheet}
          </span>
        );
      },
    },
    {
      dataField: "aprv_rej_by_name",
      text: "Approved/Rejected By",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.aprv_rej_by_name || "NA"}</span>;
      },
    },
    // {
    //   dataField: "aprv_rej_remarks",
    //   text: "Remarks",
    //   formatter: (cell, row) => {
    //     return <span className="tb-data">{row?.aprv_rej_remarks || "NA"}</span>;
    //   },
    // },
    {
      dataField: "aprv_rej_remarks",
      text: "Remarks",
      formatter: (cell, row) => {
        const maxLines = 3;

        return (
          <div
            className="tb-data"
            style={{ position: "relative", textAlign: "center" }}
          >
            <div
              style={{
                display: "-webkit-box",
                WebkitLineClamp: expanded ? "unset" : maxLines,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {row?.aprv_rej_remarks || "NA"}
            </div>
            {row?.aprv_rej_remarks?.split(" ").length > 20 && (
              <span
                onClick={() => setExpanded(!expanded)}
                style={{
                  color: "blue",
                  cursor: "pointer",
                  marginLeft: "5px",
                }}
              >
                {expanded ? "Read Less" : "Read More"}
              </span>
            )}
          </div>
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: (cell, row) => {
        return (
          <div className="d-flex gap-2">
            {isReceptionist && (
              <button
                className="actionBtn icon edit"
                onClick={() => handleEdit(row)}
              >
                <EditIcon />
              </button>
            )}

            <button
              className="actionBtn icon view"
              onClick={() => handleView(row)}
              // disabled={row?.leave_dates_with_status?.length === 0}
            >
              <ExpandIcon />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <HelmetWrapper title="WTF: Time Sheet">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={handleModalClose}
          contentLabel="Modal"
          ariaHideApp={false}
          ref={modalRef}
        >
          {modValues.cardName === "add" || modValues.cardName === "edit" ? (
            <TSForm
              userInfoData={userInfoData}
              isEdit={modValues.cardName === "edit"}
              rowData={modValues.rowData}
              closeModal={handleModalClose}
              callFunction={() => getTimeSheetDetails(filters)}
              sheetContentData={
                modValues.cardName === "edit" ? sheetContentData?.data : []
              }
              isClusterManager={isClusterManager}
              sheetData={modValues.rowData}
            />
          ) : modValues.cardName === "view" ? (
            <TSView
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              closeModal={handleModalClose}
              sheetContentData={sheetContentData?.data}
              callFunction={() => getTimeSheetDetails(filters)}
            />
          ) : null}
        </Modal>

        {isCustom && (
          <Row>
            <Col>
              <div className="mt30">
                <WelcomeUser userName={userInfoData?.name} />

                {userInfoData && !isIOS() && (
                  <Notifications authData={userInfoData} />
                )}

                {/* {isNotificationDenied === "denied" && (
                  <Alert variant={"danger"} className="mt30">
                    Notification permission is denied. Unable to display desktop
                    notifications.
                  </Alert>
                )} */}
              </div>
            </Col>
          </Row>
        )}

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Time Sheet Management"}
              createBtnTxt={
                isReceptionist && !todaySheet
                  ? "+ Add Today's Time Sheet"
                  : null
              }
              onClickCreateBtn={() =>
                isReceptionist
                  ? setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      cardName: "add",
                    }))
                  : null
              }
              isReload={() => {
                getTimeSheetDetails(filters);
              }}
              onClickBackBtn={isCustom ? handleBack : null}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <TimeSheetFilter
              isAdmin={isAdmin}
              isClusterManager={isClusterManager}
              filters={filters}
              setFilters={setFilters}
              userInfoData={userInfoData}
              handleReset={handleReset}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table mt-3">
              <PaymentLinkTable
                tableData={
                  timeSheetData?.data?.length > 0 ? timeSheetData?.data : []
                }
                tableColumns={timeSheetColumns}
                tablePagination={
                  timeSheetData?.pagination?.length > 0
                    ? timeSheetData?.pagination
                    : []
                }
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
              />
            </div>

            <div className="lead-logs-card-container only-mobile">
              <br />
              {loading ? (
                <ReactVortoxSpinner />
              ) : (
                <Accordion>
                  {timeSheetData?.data?.length > 0 &&
                    timeSheetData.data.map((row, index) => (
                      <Accordion.Item eventKey={index} key={index}>
                        <Accordion.Header>
                          <div className="w-100">
                            <div className="d-flex justify-content-between align-items-center">
                              <h5 className="lead-name mb-0">
                                <span className="lead-name">
                                  {row?.user_name || "NA"}
                                </span>
                              </h5>
                            </div>

                            <div className="d-flex gap-2 pt-2">
                              <span className={``}>
                                {row?.status?.toLowerCase() === "draft" ? (
                                  <span className="badge badge-draft">
                                    Draft
                                  </span>
                                ) : (
                                  <span className="badge badge-submitted">
                                    Sheet Submitted
                                  </span>
                                )}
                              </span>

                              {/* <span
                            className={`badge ${
                              row?.approval_status === 0
                                ? "badge-pending"
                                : row?.approval_status === 1
                                ? "badge-approved"
                                : "badge-rejected"
                            }`}
                          >
                            {row?.approval_status === 0
                              ? "Pending"
                              : row?.approval_status === 1
                              ? "Approved"
                              : "Rejected"}
                          </span> */}
                              <span className="badge bg-secondary">
                                {row?.sheet_date
                                  ? convertStraight(row.sheet_date)
                                  : "NA"}
                              </span>
                            </div>

                            <div className="d-flex gap-2 pt-2">
                              <div
                                onClick={() => handleView(row)}
                                className="approval__statusMobile flexRowCenter"
                                style={{
                                  gap: "2px",
                                  // marginTop: "7px",
                                  fontWeight: "600",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                }}
                              >
                                <span>View Time Sheet</span>

                                <span>
                                  <svg
                                    fill="none"
                                    height="14"
                                    viewBox="0 0 48 48"
                                    width="14"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M22 42H6V26"
                                      stroke="black"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="4"
                                    />
                                    <path
                                      d="M26 6H42V22"
                                      stroke="black"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="4"
                                    />
                                  </svg>
                                </span>

                                {/* <ExpandIcon /> */}
                              </div>

                              <div
                                className="approval__action flexRowCenter"
                                style={{
                                  gap: "2px",
                                  // marginTop: "7px",
                                  fontWeight: "600",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                }}
                              >
                                Approval Action
                                {row?.approval_status === 0 ? (
                                  <CrossIcon />
                                ) : (
                                  <RightIcon />
                                )}
                              </div>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="all-info-agent">
                            <div className="label-value-agent">
                              <span className="label">User Email</span>
                              <span
                                className="value"
                                style={{
                                  fontSize: "12px",
                                }}
                              >
                                {row?.user_email || "NA"}
                              </span>
                            </div>
                            <div className="label-value-agent">
                              <span className="label">Mobile</span>
                              <span className="value">
                                {row?.user_mobile || "NA"}
                              </span>
                            </div>
                            <div className="label-value-agent">
                              <span className="label">Gym Name</span>
                              <span className="value">
                                {row?.gym_name || "NA"}
                              </span>
                            </div>
                            <div className="label-value-agent">
                              <span className="label">Status</span>
                              <span className="tb-data status-dot">
                                <span
                                  className="d-inline-block rounded-circle"
                                  style={{
                                    width: "8px",
                                    height: "8px",
                                    backgroundColor:
                                      row?.status?.toLowerCase() === "draft"
                                        ? "#A0A0A0"
                                        : "#28a745",
                                  }}
                                />
                                <span
                                  style={{
                                    color:
                                      row?.status?.toLowerCase() === "draft"
                                        ? "#A0A0A0"
                                        : "#28a745",
                                  }}
                                >
                                  {row?.status?.toLowerCase() === "draft"
                                    ? "Draft"
                                    : "Submitted"}
                                </span>
                              </span>{" "}
                            </div>
                            <div className="label-value-agent">
                              <span className="label">Approval Status</span>
                              <span className="tb-data status-dot">
                                <span>
                                  {row?.total_approved}/{row?.total_timesheet}
                                </span>
                              </span>
                            </div>
                            <div className="label-value-agent">
                              <span className="label">Approval Action</span>
                              <span className="tb-data status-dot">
                                <span>
                                  {row?.approval_status === 0 ? (
                                    <CrossIcon />
                                  ) : (
                                    <RightIcon />
                                  )}

                                  {/* {row?.approval_status === 0
                                ? "Pending"
                                : row?.approval_status === 1
                                ? "Approved"
                                : "Rejected"} */}
                                </span>
                              </span>
                            </div>
                            <div className="label-value-agent">
                              <span className="label">
                                Approved/Rejected By
                              </span>
                              <span
                                className="value"
                                style={{
                                  background: "#f8f9fa",
                                  textAlign: "end",
                                }}
                              >
                                {row?.aprv_rej_by_name || "NA"}
                              </span>
                            </div>
                            <div
                              className=""
                              style={{
                                background: "#f3f0f0",
                                padding: "10px",
                                borderRadius: "4px",
                                minHeight: "50px",
                              }}
                            >
                              <span className="label">Remarks :</span>
                              <br />
                              <span className="value">
                                {row?.aprv_rej_remarks || "NA"}
                              </span>
                            </div>
                            {isReceptionist && (
                              <div className="mt-3">
                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={() => handleEdit(row)}
                                >
                                  Edit
                                </button>
                              </div>
                            )}
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                </Accordion>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default TSLanding;
